import { CardHeader, CardTitle } from "@/components/ui/card";

interface ToolCardHeaderProps {
  name: string;
  compact?: boolean;
}

export const ToolCardHeader = ({ name, compact = false }: ToolCardHeaderProps) => {
  return (
    <CardHeader className="pb-2 pt-3"> 
      <div className="flex justify-between items-start gap-2">
        <CardTitle className={`${compact ? 'text-base' : 'text-lg'} font-arabic font-semibold`}>
          {name}
        </CardTitle>
      </div>
    </CardHeader>
  );
};